import { Outlet } from 'react-router-dom'
import { GlobalStyles, Logo, Page, Layout, Content, Copyright } from './styles'
import logo from '../../../assets/logo.png'
import { connect } from 'react-redux'
import { Action, Dispatch } from "redux"

interface ComponentProps {
  company,
  companyStates
}

const Component = ({ company, companyStates }: ComponentProps) => {
  return (
    <>
      <GlobalStyles />
      <Page>
        <Layout>
          {/* <Left> */}
          <Content>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 5, alignItems: 'center', justifyContent: 'center' }}>
              <Logo src={logo} alt='Gas App' width='120px' style={{ marginBottom: 10 }} /><span>+</span><img src={company?.["logo-big"]?.url} width="150px" />
            </div>
            <Outlet />
            <Copyright>©2022 GASAPP. Todos los derechos reservados</Copyright>
          </Content>
          {/* </Left> */}
          {/* <Right /> */}
        </Layout>
      </Page>
    </>
  )
}

const state = ({ companyStore }) => {
  const { data: company, states: companyStates } = companyStore.selected
  return { company, companyStates }
}

export default connect(state)(Component)

